// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"72b38a87","144":"665f22a7","303":"4410e7ec","371":"d2338de5","376":"990e2cc9","379":"7e3c8172","466":"47c3d12a","507":"103bbd4b","511":"e9afc322","525":"a02cd237","595":"d6015dda","631":"dafc2def","769":"9ec158d3","908":"6da517a1","939":"882bb4c8"}[chunkId] + ".chunk.js";
};